<template>
  <MainLayout>
    <section class="class-detail">
      <div class="container py-2 py-md-5">
        <div class="image-model">
          <img v-bind:src="imgurl" alt="Image Alt Text" style="height: 400px; width: 800px;" />
        </div>
        <div class="ads-section p01 pt-4 pc"></div>
        <div class="ads-section p02 pt-3 tb"></div>
        <div class="ads-section m02 ads-section-01 pt-3 sp"></div>
        <div class="video-back">
          <button class="btn green" @click="$router.go(-1)">Return</button>
        </div>
      </div>
    </section>
  </MainLayout>
</template>
<script>
import MainLayout from "@/components/layout/MainLayout.vue";
export default {
  name: 'imageStreaming',
  components: {
    MainLayout,
  },
  data() {
    return {
      imgurl: null
    }
  },
  mounted() {
    this.imgurl = process.env.VUE_APP_SERVER+"my/course/"+this.$route.params.course_class_id+"/content-gp/"+this.$route.params.group_id+"/content/"+this.$route.params.id+"/download?token="+ this.$store.state.user['token'];
  },
}
</script>

<style scoped>
.btn {
  width: 15%;
  padding: 8px 0;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.2);
  background: transparent linear-gradient(-270deg, rgb(54, 182, 161) 0%, rgb(58, 175, 107) 100%);
  font-size: 16px;
  border-radius: 50px;
  color: white;
}

.video-back {
  display: flex;
  justify-content: center;
  align-items: center;
}

.image-model {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #F5F5F5;
  height: 500px;
}
</style>
